import { render, staticRenderFns } from "./BandwidthPolicy.vue?vue&type=template&id=59d6ccdc&scoped=true"
import script from "./BandwidthPolicy.vue?vue&type=script&lang=js"
export * from "./BandwidthPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6ccdc",
  null
  
)

export default component.exports